import { render } from "./ModalVacunas.vue?vue&type=template&id=13be4986&scoped=true"
import script from "./ModalVacunas.vue?vue&type=script&lang=js"
export * from "./ModalVacunas.vue?vue&type=script&lang=js"

import "./ModalVacunas.vue?vue&type=style&index=0&id=13be4986&scoped=true&lang=css"

import exportComponent from "/var/www/html/genesis-git/vue-genesis/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13be4986"]])

export default __exports__